<script lang="ts" setup>
import { logImpression } from '@bosca/analytics-client-browser'
import { initNewRelic } from '~/utils/newrelic'
import { initializeFirebase } from '~/utils/firebase'

if (import.meta.client) {
  initializeFirebase()
}

const enableTracking = true // process.env.NODE_ENV === 'production'

useHead({
  script: [
    {
      innerHTML: !enableTracking
        ? ''
        : '(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({\'gtm.start\': new Date().getTime(),event:\'gtm.js\'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s),dl=l!=\'dataLayer\'?\'&l=\'+l:\'\';j.async=true;j.src=\'https://www.googletagmanager.com/gtm.js?id=\'+i+dl;f.parentNode.insertBefore(j,f);})(window,document,\'script\',\'dataLayer\',\'GTM-TPJ7JKGB\');',
    },
    {
      src: 'https://www.googletagmanager.com/gtag/js?id=G-H9PPPEWYSZ',
      async: true,
    },
    {
      innerHTML: !enableTracking
        ? 'function gtag() { console.log(arguments); } window.gAppGtag = gtag'
        : 'window.dataLayer = window.dataLayer || []; function gtag() { dataLayer.push(arguments); } gtag(\'js\', new Date()); gtag(\'config\', \'G-H9PPPEWYSZ\'); window.gAppGtag = gtag',
    },
  ],
})

useLocaleHead({
  title: 'passionEquip',
})

useSeoMeta({
  title: 'passionEquip',
  ogTitle: 'Passion Equip',
  ogSiteName: 'Passion Equip',
  description: 'Passion Equip exists to see people around the globe know and draw closer to Jesus.',
  ogDescription: 'Passion Equip exists to see people around the globe know and draw closer to Jesus.',
  ogImage: '/og.jpg',
  ogUrl: 'https://passionequip.com/',
})

const router = useRouter()
const route = useRoute()
let scrollOffsets: number[] = []

function scrollListener() {
  const scrollTop = window.scrollY || document.documentElement.scrollTop
  const documentHeight = document.documentElement.scrollHeight - document.documentElement.clientHeight
  const scrollPercent = Math.floor(scrollTop / documentHeight * 100)
  if (isNaN(scrollPercent)) return
  if (scrollOffsets.length > 0 && scrollOffsets[0] <= scrollPercent) {
    const offset = scrollOffsets.shift()
    logImpression({
      id: 'page-scroll-' + offset,
      type: 'page',
      content: [{ id: route.fullPath, type: 'page', percent: scrollPercent }],
      extras: {
        scrolling: true,
      },
    })
  }
}

onMounted(() => {
  if (typeof window === 'undefined') return
  if (process.env.NODE_ENV === 'production') {
    try {
      initNewRelic()
    }
    catch (e) {
      console.error('failed to initialize newrelic', e)
    }
  }

  scrollOffsets = [25, 50, 75, 100]
  window.addEventListener('scroll', scrollListener)

  router.afterEach((_) => {
    setTimeout(() => {
      scrollOffsets = [25, 50, 75, 100]
    }, 1000)
  })
})

onUnmounted(() => {
  if (typeof window === 'undefined') return
  window.removeEventListener('scroll', scrollListener)
})
</script>

<template>
  <NuxtLoadingIndicator color="#7799ff" />
  <NuxtLayout>
    <NuxtPage />
  </NuxtLayout>
</template>
